export enum AptunoErrorType {
  APPLICATION = 'APPLICATION',
  BUSINESS = 'BUSINESS',
  TECHNICAL = 'TECHNICAL',
  UNKNOWN = 'UNKNOWN',
}

export const AptunoErrorTypeMapper = {
  BAD_REQUEST: AptunoErrorType.APPLICATION,
  INTERNAL_SERVER_ERROR: AptunoErrorType.TECHNICAL,
};
